import {createContext, useState} from "react";

export const ForeignerContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [foreigner, setForeigner] = useState(null);
    const [foreigners, setForeigners] = useState([]);
    const [foreignerDialog, setForeignerDialog] = useState(false);

    // Make the context object:
    const foreignerContext = {
        foreigner,
        setForeigner,
        foreigners,
        setForeigners,
        foreignerDialog,
        setForeignerDialog,
    };

    // pass the value in provider and return
    return <ForeignerContext.Provider value={foreignerContext}>{children}</ForeignerContext.Provider>;
}

export const {Consumer} = ForeignerContext;
